"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/FileUploaderViewModel.tsx"/>
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var DocumentLibraryService_1 = __importDefault(require("../../../Trillium.UI/TypeScript/Services/DocumentLibrary/DocumentLibraryService"));
var service = new DocumentLibraryService_1.default();
var allowFileType = ['png', 'jpeg', 'jpg', 'pdf', 'gif'];
var FileUploader = /** @class */ (function (_super) {
    __extends(FileUploader, _super);
    function FileUploader(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUploadBtnClick = function () {
            _this.state.fileInputField.current.click();
        };
        _this.openModal = function () {
            _this.setState(__assign(__assign({}, _this.state), { actionModal: true }));
        };
        _this.closeModal = function () {
            _this.setState(__assign(__assign({}, _this.state), { actionModal: false }));
        };
        _this.addNewFiles = function (newFiles) {
            for (var _i = 0, newFiles_1 = newFiles; _i < newFiles_1.length; _i++) {
                var file = newFiles_1[_i];
                if (file.size <= _this.props.maxFileSizeInBytes && allowFileType.includes(file.name.split('.').pop().toLowerCase())) {
                    if (!_this.props.multiple) {
                        return { file: file };
                    }
                    _this.state.files[file.name] = file;
                    return __assign({}, _this.state.files);
                }
                else {
                    _this.setState(__assign(__assign({}, _this.state), { errorMessage: 'File details not match with requirements' }));
                }
            }
        };
        _this.handleNewFileUpload = function (e) {
            var newFiles = e.target.files;
            if (newFiles.length) {
                var updatedFiles = _this.addNewFiles(newFiles);
                if (updatedFiles)
                    _this.setState(__assign(__assign({}, _this.state), { files: updatedFiles, errorMessage: "" }));
            }
        };
        _this.dataFile = function (file) { return new Promise(function (resolve, rejects) {
            var reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = function (e) { return rejects(e); };
        }); };
        _this.uploadFile = function () { return __awaiter(_this, void 0, void 0, function () {
            var folderName, bufferArray, file, fileByteArray, _i, file_1, a, uploadDate, i, res, splitName, newName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(Object.keys(this.state.files).length === 1)) return [3 /*break*/, 5];
                        this.setState(__assign(__assign({}, this.state), { loader: true }));
                        folderName = this.props.folderUrl.split('/').pop();
                        return [4 /*yield*/, this.dataFile(this.state.files.file)];
                    case 1:
                        bufferArray = _a.sent();
                        file = new Uint8Array(bufferArray);
                        fileByteArray = [];
                        for (_i = 0, file_1 = file; _i < file_1.length; _i++) {
                            a = file_1[_i];
                            fileByteArray.push(a);
                        }
                        uploadDate = {
                            folderUrl: this.props.folderUrl,
                            folderName: folderName,
                            fileName: this.state.files.file.name,
                            fileContent: fileByteArray,
                            parentFolder: this.props.parentFolder
                        };
                        i = 1;
                        _a.label = 2;
                    case 2:
                        if (!(i <= 100)) return [3 /*break*/, 5];
                        return [4 /*yield*/, service.uploadDocumentFile(uploadDate)];
                    case 3:
                        res = _a.sent();
                        if (res.Success) {
                            this.setState(__assign(__assign({}, this.state), { loader: false }));
                            this.fileUploadSucess(folderName);
                            return [3 /*break*/, 5];
                        }
                        else {
                            splitName = this.state.files.file.name.split(/\.(?=[^\.]+$)/);
                            newName = splitName[0] + ' (' + i + ').' + splitName[1];
                            uploadDate.fileName = newName;
                        }
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.fileUploadSucess = function (folderName) {
            _this.setState(__assign(__assign({}, _this.state), { files: [] }));
            _this.closeModal();
            _this.props.refresh({ Url: _this.props.folderUrl, Name: folderName });
        };
        _this.removeFile = function () {
            _this.setState(__assign(__assign({}, _this.state), { files: {} }));
        };
        _this.state = {
            files: [],
            fileInputField: react_1.default.createRef(),
            actionModal: false,
            errorMessage: "",
            loader: false,
        };
        return _this;
    }
    FileUploader.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("button", { className: 'btn btn-primary btn-primary-outline', onClick: function () { return _this.openModal(); } }, this.props.uploadNewDocument),
            react_1.default.createElement(core_1.Dialog, { open: this.state.actionModal, onClose: this.closeModal, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", maxWidth: "md", className: 'ipd-portal ipd-dialog-file-uploader' },
                react_1.default.createElement(core_1.DialogTitle, { id: "alert-dialog-title", className: 'up-padding' },
                    this.props.uploadNewDocument,
                    react_1.default.createElement("img", { src: '/images/icons/close.svg', className: 'closeIcon cursor-pointer', onClick: this.closeModal })),
                react_1.default.createElement(core_1.DialogContent, { className: 'file-padding' },
                    react_1.default.createElement("div", { className: 'row fileupload' },
                        react_1.default.createElement("div", { className: 'col-md-12 nopadding' },
                            react_1.default.createElement("div", { className: 'fileBox' },
                                react_1.default.createElement("div", { className: 'fileIcon' },
                                    react_1.default.createElement("i", { className: "fas fa-cloud-upload-alt" })),
                                react_1.default.createElement("p", null, ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.file) ? this.state.files.file.name : react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("span", null, "Add file"),
                                    " or drop file here")),
                                react_1.default.createElement("input", { type: "file", title: "", accept: "image/*,application/pdf", value: "", ref: this.state.fileInputField, onChange: function (e) { return _this.handleNewFileUpload(e); } })))),
                    this.state.errorMessage ? react_1.default.createElement("p", { className: 'mb-0 alert-warning', dangerouslySetInnerHTML: { __html: this.state.errorMessage } }) : null,
                    react_1.default.createElement("p", { className: 'mb-0 uploadtext', dangerouslySetInnerHTML: { __html: this.props.minMaxText } }),
                    react_1.default.createElement("p", { className: 'mb-0 uploadtext', dangerouslySetInnerHTML: { __html: this.props.fileTypeMessage } })),
                react_1.default.createElement(core_1.DialogActions, null, Object.keys(this.state.files).length ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Button, { onClick: this.removeFile, color: "primary", className: 'btn btn-primary btn-primary-outline mr-auto' }, this.props.removeButton),
                    this.state.loader && react_1.default.createElement("div", { className: "spinner-border loading-indicator" }),
                    react_1.default.createElement(core_1.Button, { onClick: this.uploadFile, color: "primary", className: 'btn btn-primary btn-primary-outline' }, this.props.uploadButton)) :
                    react_1.default.createElement(core_1.Button, { onClick: this.closeModal, color: "primary", className: 'btn btn-primary btn-primary-outline mr-auto' }, this.props.cancleButton)))));
    };
    return FileUploader;
}(react_1.default.Component));
;
exports.default = FileUploader;
